import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { PriceLineItem, PriceBreakupAccordion } from 'app/components';
import { getPriceBreakup } from '../api';

const PriceBreakup = (props) => {
  const {
    eventId,
    ticketId,
    state,
    count,
    isPaid,
  } = props;

  const dispatch = useDispatch();
  const { priceBreakup } = useSelector((state) => state.primaryBuyerFlow);
  const { activeRequests } = useSelector((state) => state.app);
  const isLoading = activeRequests?.includes('get-price-breakup');

  useEffect(() => {
    if (isPaid) {
      getPriceBreakup({ id: eventId, ticketId, state, count }, (resp) => {
        dispatch({ type: "PRICE_BREAKUP:SET", data: resp?.failure ? null : resp?.data });
      });
    } else {
      dispatch({ type: "PRICE_BREAKUP:SET", data: null });
    }
  }, [count, state, isPaid]);

  return (
    <div className="flex flex-col gap-4 pt-4">
      <PriceLineItem label="Ticket Price" price={priceBreakup?.items?.[0]?.ticket_price || 0} isLoading={isLoading} />
      <PriceBreakupAccordion
        title="Booking Fees(incl. GST)"
        price={priceBreakup?.items?.[0]?.total_booking_fee || 0}
        isLoading={isLoading}
        content={(
          <div className='flex flex-col gap-3 pt-3'>
            <div className="horizontal-divider" />
            <PriceLineItem label="Base Price" price={priceBreakup?.items?.[0]?.base_price || 0} priceClass="label-14" labelClass="text-14" isLoading={isLoading} />
            <PriceLineItem label="Taxes @ 18%" price={priceBreakup?.items?.[0]?.taxes || 0} priceClass="label-14" labelClass="text-14" isLoading={isLoading} />
          </div>
        )}
      />
      <div className="horizontal-divider" />
      <PriceLineItem label="Total Amount" price={priceBreakup?.items?.[0]?.final_amount || 0} bold={true} labelClass="text-black" isLoading={isLoading} />
    </div>
  );
};

export default PriceBreakup;
